/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.0.1
 */

import { icons } from '../../../../assets';
import { TextBlock } from '../../../../components/common';
import { FlexColumnMiddleStyled } from '../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../components/common/Block/Img';
import { LayoutBoxStyled } from '../../../../components/common/Block/Layout';
import { colors } from '../../../../theme';

interface IWidgetErrorProps {
    className?: string;
    text: string;
}

const WidgetError = (props: IWidgetErrorProps) => (
    <FlexColumnMiddleStyled className={`widget-personal-account__error ${props.className || ''}`}>
        <LayoutBoxStyled
            background={colors.backgroundColorModal}
            borderRadius="100%"
            className="mb-3"
            padding="20px"
            width="72px"
        >
            <ImgStyled className="medium" src={icons.infoGreyIcon}/>
        </LayoutBoxStyled>
        <TextBlock>{props.text}</TextBlock>
    </FlexColumnMiddleStyled>
);

export default WidgetError;
